import { useState, useEffect } from 'react';
import { getComptesClubConsole, roleCompte } from '../api';

const ROLE = { admin_club:'admin club', admin:'admin club', coach:'coach', tresorier:'trésorier', admin_3mt:'trésorier', joueur:'joueur' };
const CONDITIONS = {
  validees:       { txt:'✓ conditions validées', coul:'#22c55e' },
  a_valider:      { txt:'⏳ conditions à valider', coul:'#eab308' },
  attente_parent: { txt:'👨‍👧 en attente du parent', coul:'#93c5fd' },
};
function connexion(d) {
  if (!d) return 'jamais connecté';
  const jours = Math.floor((Date.now() - new Date(d.replace(' ', 'T') + 'Z')) / 86400000);
  return jours <= 0 ? "connecté aujourd'hui" : jours === 1 ? 'connecté hier' : `connecté il y a ${jours} j`;
}

/** Comptes d'un club, regroupés par équipe en sections repliables — vue de l'éditeur. */
export default function ComptesParEquipe({ clubId, notifier }) {
  const [d, setD] = useState(null);
  const [ouverts, setOuverts] = useState({ admin: true });
  const charger = () => getComptesClubConsole(clubId).then(setD).catch(e => notifier?.(e.message, 'error'));
  useEffect(() => { charger(); }, [clubId]);
  const changerRole = async (c, role) => {
    if (role === c.role || (role === 'admin_club' && c.role === 'admin')) return;
    try {
      const r = await roleCompte(c.id, role);
      notifier?.(r.sans_equipe
        ? `${c.nom || c.username} est maintenant ${ROLE[role]}, mais n'est rattaché à aucune équipe : il ne verra rien tant qu'il n'y est pas rattaché.`
        : `${c.nom || c.username} est maintenant ${ROLE[role]}.`, r.sans_equipe ? 'error' : 'success');
      charger();
    } catch (e) { notifier?.(e.message, 'error'); }
  };
  if (!d) return <div style={{ color:'var(--muted)', fontSize:12.5 }}>Chargement des comptes…</div>;

  const basculer = k => setOuverts(o => ({ ...o, [k]: !o[k] }));
  const groupes = [
    { cle:'admin', titre:'Administration du club', comptes:d.administration },
    ...d.equipes.map(g => ({ cle:`e${g.equipe.id}`, titre:g.equipe.nom + (g.equipe.actif ? '' : ' (archivée)'), comptes:g.comptes })),
    ...(d.sans_equipe.length ? [{ cle:'sans', titre:'Sans équipe', comptes:d.sans_equipe, alerte:true }] : []),
  ];

  return (
    <div>
      {groupes.map(g => {
        const aValider = g.comptes.filter(c => c.conditions !== 'validees').length;
        const jamais = g.comptes.filter(c => !c.derniere_connexion).length;
        return (
          <div key={g.cle} style={{ border:'1px solid var(--border)', borderRadius:9, marginBottom:6, overflow:'hidden' }}>
            <button type="button" onClick={() => basculer(g.cle)} aria-expanded={!!ouverts[g.cle]}
                    style={{ width:'100%', display:'flex', justifyContent:'space-between', alignItems:'center', gap:8,
                             background:'none', border:'none', color:'var(--text)', padding:'9px 11px', cursor:'pointer', textAlign:'left' }}>
              <span style={{ fontSize:13, fontWeight:700, color: g.alerte ? '#eab308' : 'var(--text)' }}>
                {ouverts[g.cle] ? '▾' : '▸'} {g.titre}
                <span style={{ fontWeight:400, color:'var(--muted)' }}> · {g.comptes.length} compte{g.comptes.length > 1 ? 's' : ''}</span></span>
              <span style={{ fontSize:11, color:'var(--muted)', whiteSpace:'nowrap' }}>
                {aValider > 0 && <span style={{ color:'#eab308' }}>{aValider} à valider</span>}
                {aValider > 0 && jamais > 0 && ' · '}
                {jamais > 0 && <span>{jamais} jamais connecté{jamais > 1 ? 's' : ''}</span>}</span>
            </button>
            {ouverts[g.cle] && (
              <div style={{ padding:'2px 11px 8px' }}>
                {g.comptes.length === 0 && <div style={{ fontSize:12, color:'var(--muted)', padding:'4px 0' }}>Aucun compte</div>}
                {g.comptes.map(c => (
                  <div key={c.id} style={{ padding:'6px 0', borderTop:'1px solid var(--border)', opacity: c.actif ? 1 : .5 }}>
                    <div style={{ display:'flex', justifyContent:'space-between', gap:8, fontSize:12.5 }}>
                      <span style={{ fontWeight:600 }}>{c.nom || c.username}
                        <span style={{ fontWeight:400, color:'var(--muted)' }}> · {c.username}</span></span>
                      <span style={{ fontSize:11.5, whiteSpace:'nowrap', display:'flex', alignItems:'center', gap:5 }}>
                        {!c.actif && <span style={{ color:'var(--muted)' }}>suspendu</span>}
                        <select value={c.role === 'admin' ? 'admin_club' : c.role} aria-label={`Rôle de ${c.nom || c.username}`}
                                onChange={e => changerRole(c, e.target.value)}
                                style={{ background:'var(--bg)', color:'var(--text)', border:'1px solid var(--border)', borderRadius:6,
                                         fontSize:11.5, padding:'2px 4px', cursor:'pointer' }}>
                          {['joueur', 'tresorier', 'coach', 'admin_club'].map(r => <option key={r} value={r}>{ROLE[r]}</option>)}
                        </select></span>
                    </div>
                    <div style={{ fontSize:11, marginTop:2, display:'flex', gap:10, flexWrap:'wrap' }}>
                      <span style={{ color: CONDITIONS[c.conditions]?.coul }}>{CONDITIONS[c.conditions]?.txt}</span>
                      <span style={{ color: c.derniere_connexion ? 'var(--muted)' : '#eab308' }}>{connexion(c.derniere_connexion)}</span>
                      {c.email && <span style={{ color:'var(--muted)' }}>{c.email}</span>}
                    </div>
                  </div>))}
              </div>)}
          </div>);
      })}
    </div>
  );
}
